import { useAuth } from './AuthContext';
import { Badge } from './ui/badge';

const API = process.env.REACT_APP_BACKEND_URL;

const AppBranding = () => {
  const { user } = useAuth();

  const level = user?.access_level || 'FREE';
  const mode = user?.mode || 'simulation';

  return (
    <div className="text-center py-6 border-b border-[#003B00]" style={{ background: 'rgba(5, 5, 5, 0.9)' }} data-testid="app-branding">
      <div className="flex justify-center mb-4">
        <img
          src="/bitbot-logo.png"
          alt="BitBot"
          className="w-auto"
          style={{ height: '225px' }}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      </div>
      <h1
        className="text-3xl font-bold text-[#00FF41] tracking-wider"
        style={{ fontFamily: 'Courier New, monospace', textShadow: '0 0 15px #00FF41' }}
        data-testid="branding-title"
      >
        BITBOT V3.9.32 [LIVE]
      </h1>
      <p className="text-[#008F11] text-sm tracking-widest mt-1">
        AUTOMATED CRYPTOCURRENCY TRADING
      </p>
      <div className="flex items-center justify-center gap-2 mt-3">
        <Badge
          className={`${mode === 'live' ? 'mode-live' : 'mode-simulation'} rounded-none text-[10px]`}
          data-testid="branding-mode-badge"
        >
          {mode === 'simulation' ? 'SIMULATION' : 'LIVE'}
        </Badge>
        <Badge
          className={`rounded-none text-[10px] font-bold ${
            level === 'GOD' ? 'bg-red-900 text-red-200 border border-red-600' :
            level === 'FAMILY' ? 'bg-purple-900 text-purple-200 border border-purple-600' :
            level === 'PAID' ? 'bg-blue-900 text-blue-200 border border-blue-600' :
            'bg-gray-800 text-gray-300 border border-gray-600'
          }`}
          data-testid="branding-level-badge"
        >
          {level === 'GOD' ? 'GOD MODE' :
           level === 'FAMILY' ? 'FAMILY' :
           level === 'PAID' ? 'PAID TIER' :
           'FREE TIER'}
        </Badge>
      </div>
    </div>
  );
};

export default AppBranding;
